function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_644",
  "data-name": "Path 644",
  d: "M160.774,67.538a4.315,4.315,0,0,0-2.853,1.078l-4.827-4.827a4.311,4.311,0,0,0-.122-4.356l4.718-4.717a4.337,4.337,0,1,0-.706-.942l-4.756,4.756a4.336,4.336,0,1,0,.166,6.2l4.76,4.76a4.335,4.335,0,1,0,3.622-1.956Zm0-19.039a3.172,3.172,0,1,1-3.173,3.172A3.176,3.176,0,0,1,160.774,48.5ZM149.287,64.883a3.172,3.172,0,1,1,3.173-3.172A3.176,3.176,0,0,1,149.287,64.883Zm11.487,10.165a3.173,3.173,0,1,1,3.172-3.173A3.177,3.177,0,0,1,160.774,75.048Z",
  transform: "translate(-144.95 -47.333)",
  fill: "#d71635"
});

var SvgIconShare = function SvgIconShare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.161,
    height: 28.88,
    viewBox: "0 0 20.161 28.88",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconShare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iconShare.71f0fb91.svg";
export { ForwardRef as ReactComponent };